import React from "react";

const AboutSection = () => {
  const BROWN = "#5b3a29";
  const OLIVE = "#8a8f3a";
  const WHITE = "#ffffff";

  const styles = {
    section: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexWrap: "wrap",
      padding: "100px 20px",
      background: WHITE,
      gap: "50px",
      fontFamily: "Poppins, sans-serif",
    },
    textBox: {
      flex: "1 1 450px",
      maxWidth: "600px",
    },
    title: {
      color: BROWN,
      fontSize: "38px",
      fontWeight: "700",
      marginBottom: "20px",
      position: "relative",
    },
    subtitle: {
      color: OLIVE,
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      textTransform: "uppercase",
      letterSpacing: "2px",
    },
    paragraph: {
      color: "#444",
      fontSize: "17px",
      lineHeight: "1.8",
      marginBottom: "25px",
    },
    button: {
      background: BROWN,
      color: WHITE,
      border: "none",
      padding: "12px 26px",
      borderRadius: "8px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background 0.3s ease",
    },
    imageBox: {
      flex: "1 1 400px",
      textAlign: "center",
    },
    image: {
      width: "100%",
      maxWidth: "450px",
      borderRadius: "16px",
      boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
    },
  };

  return (
    <section style={styles.section}>
      <div className="container">
        <div style={styles.textBox}>
        <h4 style={styles.subtitle}>Our Story</h4>
        <h2 style={styles.title}>The Soul Behind Every Handcrafted Piece</h2>
        <p style={styles.paragraph}>
          At <strong>L’ARTISAN</strong>, every creation tells a story — a story
          of passion, patience, and precision.  
          From carefully selecting natural wood to the final touch of polish,
          our artisans pour their hearts into crafting timeless pieces
          that bring warmth and elegance to your home.
        </p>
        <p style={styles.paragraph}>
          Each product is more than décor — it’s a piece of art, a celebration
          of craftsmanship, and a bridge between nature and design.
        </p>
        <style>
          {`
            button:hover {
              background: ${OLIVE};
            }
          `}
        </style>
      </div>

      <div style={styles.imageBox}>
        <img
          src="https://res.cloudinary.com/dys8jv8c2/image/upload/v1762195945/freepik__a-skilled-female-carpenter-carving-wood-detailed-c__71517_uccrjf.webp"
          alt="Our Artisan Story"
          style={styles.image}
        />
      </div>
      </div>
    </section>
  );
};

export default AboutSection;
